import React from 'react';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import SearchDropdown from '../../../components/organisms/searchDropdown';

const SearchDropdownTastic = ({ data, context, isServerSideRendering }) => {
  const isSSR = typeof isServerSideRendering === 'boolean' && isServerSideRendering;
  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';

  if (!data[`show${locale}`]) return null;

  return <SearchDropdown isSSR={isSSR} currency={context.currency} {...data} />;
};

export default tastify({ translate: true, connect: { context: true } })(SearchDropdownTastic);
